<template>
  <div class="case">
    <div class="case-product">
      <div class="case-product-content">
        <el-breadcrumb
          separator="/"
          style="margin-top: -40px; margin-bottom: 30px"
        >
          <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'policy' }"
            >政策法规</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ dataList.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <h3
          style="
            display: flex;
            justify-content: center;
            margin: 10px 0px;
          "
        >
          {{ dataList.title }}
        </h3>
        <p style="display: flex; justify-content: center; margin: 10px 0px">
          发布时间：{{ dataList.createTime }}
        </p>
        <img v-lazy="dataList.img" alt /> -->
        <p class="product-content" v-html="dataList.content" style="margin-top: 30px;"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PolicyDetails",
  components: {},
  data() {
    return {
      pid: 0,
      dataList: {},
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http
        .get(`api/website/resource/getDetail/${this.pid}`)
        .then((response) => {
          this.dataList = response.data.data;
          window.console.log(this.dataList);
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    &-content {
      margin: 15 auto;
      display: flex;
      flex-direction: column;
      padding: 50px 0;
      img {
        width: 100%;
      }
    }
  }
}
</style>